/**
 * Abaco Brands — Teacher Toolkit Popup timing (Part 2)
 *
 * Handles:
 *   - Showing the popup N seconds after load (data-ttk-delay)
 *   - Showing the popup on exit intent (data-ttk-exit-intent)
 *   - Suppressing the popup for N days after it's dismissed OR converted
 *     (data-ttk-suppress-days), stored in localStorage with an expiry so we
 *     don't need a server round-trip or a cookie-consent-gated cookie write.
 *
 * Depends on teacher-toolkit.js loading first (shared form submit handler
 * already binds to [data-ttk-form] inside the popup markup).
 */
(function () {
  'use strict';

  var DISMISS_KEY = 'ttk_popup_dismissed_until';

  function getPopupEl() {
    return document.querySelector('[data-ttk-popup]');
  }

  function isSuppressed() {
    try {
      var until = Number(localStorage.getItem(DISMISS_KEY) || 0);
      return Date.now() < until;
    } catch (e) {
      return false; // localStorage unavailable — fail open, show once per session only
    }
  }

  function alreadyConverted() {
    try {
      return localStorage.getItem('ttk_converted') === '1';
    } catch (e) {
      return false;
    }
  }

  function suppressFor(days) {
    try {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(DISMISS_KEY, String(until));
    } catch (e) {
      /* non-fatal */
    }
  }

  function showPopup(popup) {
    if (popup.dataset.ttkShown === '1') return;
    popup.hidden = false;
    popup.dataset.ttkShown = '1';
    document.body.style.overflow = 'hidden';

    var firstInput = popup.querySelector('input');
    if (firstInput) {
      // Delay focus until the pop-in animation is underway so it doesn't
      // feel abrupt to screen reader / keyboard users.
      window.setTimeout(function () { firstInput.focus(); }, 200);
    }
  }

  function hidePopup(popup, suppressDays) {
    popup.hidden = true;
    document.body.style.overflow = '';
    suppressFor(suppressDays);
  }

  function init() {
    var popup = getPopupEl();
    if (!popup) return;

    if (isSuppressed() || alreadyConverted()) return;

    var delaySeconds = Number(popup.getAttribute('data-ttk-delay')) || 8;
    var exitIntentEnabled = popup.getAttribute('data-ttk-exit-intent') === 'true';
    var suppressDays = Number(popup.getAttribute('data-ttk-suppress-days')) || 30;

    var timerId = window.setTimeout(function () {
      showPopup(popup);
    }, delaySeconds * 1000);

    if (exitIntentEnabled) {
      var exitHandler = function (event) {
        // Only trigger when the mouse leaves via the top of the viewport —
        // the classic "heading for the tab bar" signal, on desktop only.
        if (event.clientY <= 0) {
          showPopup(popup);
          document.removeEventListener('mouseleave', exitHandler);
        }
      };
      document.addEventListener('mouseleave', exitHandler);
    }

    popup.querySelectorAll('[data-ttk-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        window.clearTimeout(timerId);
        hidePopup(popup, suppressDays);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) {
        hidePopup(popup, suppressDays);
      }
    });

    // A successful signup (from teacher-toolkit.js) should also permanently
    // suppress the popup, not just for the default window.
    document.addEventListener('ttk:converted', function () {
      suppressFor(365);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
